import api from '@/api/axiosApi'
import type {
  DagMetadataResponse,
  DagTableLoadResponse,
  BatchPatchRequest,
  BatchPatchResponse,
  DropdownAllResponse,
} from '@/types/dag'

export async function fetchDagMetadata(
  planId: string,
  versionId: string
): Promise<DagMetadataResponse> {
  const { data } = await api.get<DagMetadataResponse>(
    `/plans/${planId}/versions/${versionId}/table/dag-metadata`
  )
  return data
}

export async function fetchDagRows(
  planId: string,
  versionId: string,
  offset: number,
  limit: number,
  searchQuery?: string
): Promise<DagTableLoadResponse> {
  const { data } = await api.get<DagTableLoadResponse>(
    `/plans/${planId}/versions/${versionId}/table/rows`,
    {
      params: {
        offset,
        limit,
        include_aggregates: true,
        sort: '-created_at',
        ...(searchQuery ? { q: searchQuery } : {}),
      },
    }
  )
  return data
}

export async function patchDagRows(
  planId: string,
  versionId: string,
  payload: BatchPatchRequest
): Promise<BatchPatchResponse> {
  const { data } = await api.patch<BatchPatchResponse>(
    `/plans/${planId}/versions/${versionId}/table/rows`,
    payload
  )
  return data
}

export async function fetchDropdowns(): Promise<DropdownAllResponse> {
  const { data } = await api.get<DropdownAllResponse>(
    '/api/v1/lookups/dropdowns'
  )
  return data
}
